import type { ReactNode } from "react";
import { Children, cloneElement, isValidElement } from "react";
import type { FieldError, UseFormRegisterReturn } from "react-hook-form";

import { FormFieldError } from "@/components/form/FormFieldError";
import { Label } from "@/components/text/Label";

export function FormField({
  id,
  label,
  error,
  children,
  register,
}: {
  id: string;
  label: string;
  error: FieldError["message"] | null;
  children: ReactNode;
  register: UseFormRegisterReturn | null;
}) {
  const childrenWithRegister =
    register !== null ?
      Children.map(children, (child) => {
        if (isValidElement(child)) {
          return cloneElement(child, { ...register });
        }
        return child;
      })
    : children;

  return (
    <div className="space-y-2">
      <Label htmlFor={id} elementType="label">
        {label}
      </Label>
      {childrenWithRegister}
      <FormFieldError error={error} />
    </div>
  );
}
